import type { ReactNode } from 'react';

interface SectionContainerProps {
  children: ReactNode;
  className?: string;
}

export default function SectionContainer({ children, className }: SectionContainerProps) {
  return (
    <section
      className={`w-full bg-light-background px-4 py-10 dark:bg-base-fill-primary pad:px-8 pad:py-16 pc-small:py-20 ${className ?? ''}`}
    >
      <div className="mx-auto w-full max-w-[1200px]">{children}</div>
    </section>
  );
}
